export const TRANSLATIONS_EN_GENERATION = {
  "generate.title": "Generate document",
  "generate.subtitle": "Executive summary from selected sources",
  "generate.action": "Generate",
  "generate.generating": "Generating...",
  "generate.sources.title": "Sources",
  "generate.sources.clear": "Clear selection",
  "generate.sources.loading": "Loading documents...",
  "generate.language": "Language",
  "generate.expertRole": "Expert",
  "generate.expertRole.general": "General",
  "generate.message.label": "Message for the summary (optional)",
  "generate.message.placeholder": "E.g.: focus on risks and next steps…",
  "generate.message.counter": "{count}/{max}",
  "generate.validation.selectSource": "Select at least one source.",
  "generate.toast.success": "Draft generated.",
  "generate.toast.enqueued": "Generation queued. It will be ready in a few minutes; we'll notify you.",
  "generate.errors.documents": "Could not load documents.",
  "generate.errors.forbidden": "Your plan cannot generate documents or the quota was reached.",
  "generate.errors.insufficientEvidence": "The selected evidence is not sufficient.",
  "generate.errors.generic": "Could not generate the document.",
  "generate.errors.download": "Could not download the PDF.",
  "generate.picker.title": "Which documents do you want to select to generate your summary?",
  "generate.picker.searchPlaceholder": "Search documents…",
  "generate.picker.empty": "No documents found.",
  "generate.picker.selected": "selected",
  "generate.picker.confirm": "Done",
  "generate.picker.open": "Select documents",
  "generate.sources.empty": "No documents selected yet. Use “Select documents” to choose them.",
  "generate.warnings.sourcesUnavailable": "Some sources are no longer available and were removed. Query them again if you need them.",
  "generate.preview.title": "Preview",
  "generate.preview.empty": "Select sources and generate the draft.",
  "generate.download": "Download PDF",
  "generate.downloading": "Downloading...",
  "generate.mySummaries": "Generated Documents",
  "generate.history.title": "Generated Documents",
  "generate.history.subtitle": "History of generated executive summaries",
  "generate.export.docx": "Download DOCX",
  "generate.export.draftWatermark": "The download will include a DRAFT watermark (document not approved)",
  "generate.history.notify.ready": "Your executive summary is ready.",
  "generate.history.notify.failed": "The summary could not be generated.",
  "generate.history.pagination.label": "Pagination",
  "generate.history.pagination.prev": "Previous",
  "generate.history.pagination.next": "Next",
  "generate.history.unnamedDocument": "Document",
  "generate.history.enqueuedBanner": "Your summary is being generated in the background. We'll notify you when it's ready; you can keep working.",
  "generate.history.dismiss": "Dismiss",
  "generate.history.new": "New summary",
  "generate.history.col.files": "Files",
  "generate.history.col.created": "Created",
  "generate.history.col.status": "Status",
  "generate.history.col.expert": "Expert",
  "generate.history.expert.general": "General",
  "generate.history.col.actions": "Actions",
  "generate.history.status.downloaded": "Downloaded",
  "generate.history.status.pending": "Pending",
  "generate.history.status.processing": "Processing",
  "generate.history.status.completed": "Completed",
  "generate.history.status.failed": "Failed",
  "generate.history.action.download": "Download PDF",
  "generate.history.action.regenerate": "Regenerate",
  "generate.history.empty": "You haven't generated any summaries yet.",
  "generate.history.emptyCta": "Generate my first summary",
  "generate.history.loading": "Loading summaries...",
  "generate.history.error": "Could not load the summaries.",
  "generate.history.retry": "Retry",
  "generate.history.moreFiles": "+{count}",
  "generate.history.col.message": "Message",
  "generate.history.noMessage": "—",
  "generate.lifecycle.tabs.label": "Filter by status",
  "generate.lifecycle.tab.all": "All",
  "generate.lifecycle.tab.draft": "Drafts",
  "generate.lifecycle.tab.in_review": "In review",
  "generate.lifecycle.tab.approved": "Approved",
  "generate.lifecycle.tab.rejected": "Rejected",
  "generate.lifecycle.tab.archived": "Archived",
  "generate.lifecycle.status.draft": "Draft",
  "generate.lifecycle.status.in_review": "In review",
  "generate.lifecycle.status.approved": "Approved",
  "generate.lifecycle.status.rejected": "Rejected",
  "generate.lifecycle.status.archived": "Archived",
  "generate.lifecycle.col.version": "Version",
  "generate.lifecycle.action.submit": "Submit for review",
  "generate.lifecycle.action.approve": "Approve",
  "generate.lifecycle.action.reject": "Reject",
  "generate.lifecycle.action.archive": "Archive",
  "generate.lifecycle.action.timeline": "View change history",
  "generate.lifecycle.action.revise": "Revise and resubmit",
  "generate.lifecycle.action.unarchive": "Restore",
  "generate.lifecycle.confirm.title": "Confirm action",
  "generate.lifecycle.confirm.submit": "Submit this summary for review?",
  "generate.lifecycle.confirm.approve": "Approve this summary? It will be marked as reviewed content.",
  "generate.lifecycle.confirm.archive": "Archive this summary? It will no longer be active.",
  "generate.lifecycle.confirm.cancel": "Cancel",
  "generate.lifecycle.confirm.accept": "Confirm",
  "generate.lifecycle.reject.title": "Reject summary",
  "generate.lifecycle.reject.reasonLabel": "Rejection reason (required)",
  "generate.lifecycle.reject.placeholder": "Explain why this summary is being rejected...",
  "generate.lifecycle.reject.confirm": "Reject",
  "generate.lifecycle.confirm.revise": "Return this summary to draft to fix it? You can submit it for review again.",
  "generate.lifecycle.confirm.unarchive": "Restore this archived summary? It will return to draft.",
  "generate.lifecycle.toast.submitted": "Summary submitted for review.",
  "generate.lifecycle.toast.approved": "Summary approved.",
  "generate.lifecycle.toast.rejected": "Summary rejected.",
  "generate.lifecycle.toast.archived": "Summary archived.",
  "generate.lifecycle.toast.revised": "Summary returned to draft.",
  "generate.lifecycle.toast.unarchived": "Summary restored to draft.",
  "generate.lifecycle.toast.error": "The action could not be completed. Please try again.",
  "generate.detail.view": "View detail",
  "generate.detail.title": "Summary detail",
  "generate.detail.close": "Close",
  "generate.detail.empty": "This summary has no content to display.",
  "generate.lifecycle.timeline.title": "Status change history",
  "generate.lifecycle.timeline.empty": "No transitions recorded.",
  "generate.lifecycle.timeline.error": "The change history could not be loaded.",
  "generate.lifecycle.timeline.close": "Close",
  "generate.lifecycle.generatedByAi": "AI-generated content: review it before using it as an official document.",
  "generate.lifecycle.draftBadge": "DRAFT — not approved",
};
